<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
      </div>
      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="Type of cargo">
            <input [(ngModel)]="exemption.typeOfCargo" id="typeOfCargo" type="text" maxlength="256"
                   class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Decontamination company name">
            <input [(ngModel)]="exemption.decontaminationCompanyName" id="decontaminationCompanyName" type="text"
                   maxlength="256" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Name of gassing contractor foreman">
            <input [(ngModel)]="exemption.nameOfGassingContractorForeman" id="nameOfGassingContractorForeman"
                   type="text" maxlength="256" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Decontamination company address">
            <textarea [(ngModel)]="exemption.decontaminationCompanyAddress" id="decontaminationCompanyAddress"
                      type="text" rows="3" maxlength="1024" class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Decontamination company phone number">
            <input [(ngModel)]="exemption.decontaminationCompanyPhoneNumber" id="decontaminationCompanyPhoneNumber"
                   type="text" maxlength="256" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Disinfectants to be used">
            <input [(ngModel)]="exemption.disinfectantsToBeUsed" id="disinfectantsToBeUsed" type="text"
                   maxlength="256" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Name of owner of the service vessel (if being used)">
            <input [(ngModel)]="exemption.nameOfOwnerOfTheVessel" id="nameOfOwnerOfTheVessel" type="text"
                   maxlength="256" class="form-control">
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>From</label>
              <div class="tooltipContent">Duration of decontamination activities, applying gas pressure or venting</div>
            </app-info>
            <app-date-field [(ngModel)]="exemption.from" id="from" required></app-date-field>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>To</label>
              <div class="tooltipContent">Duration of decontamination activities, applying gas pressure or venting</div>
            </app-info>
            <app-date-field [(ngModel)]="exemption.to" id="to" required></app-date-field>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
